import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageEventsComponent } from './manage-events/manage-events.component';
import { ManageRegistrationsComponent } from './manage-registrations/manage-registrations.component';
import { ManageEventsBiddingsComponent } from './manage-events-biddings/manage-events-biddings.component';
import { CurdEventsBiddingsComponent } from './curd-events-biddings/curd-events-biddings.component';
import { EventsFeedbackComponent } from './events-feedback/events-feedback.component';
import { ManageForumsComponent } from './manage-forums/manage-forums.component';
import { CrudForumComponent } from './crud-forum/crud-forum.component';
import { CrudEventsComponent } from './crud-events/crud-events.component';
import { ManageForumRegistrationsComponent } from './manage-forum-registrations/manage-forum-registrations.component';

const routes: Routes = [
  {
    path: '',
    component: ManageEventsComponent,
  },
  {
    path: 'crud',
    component: CrudEventsComponent,
  },
  {
    path: 'crud/:id',
    component: CrudEventsComponent,
  },
  {
    path: 'registrations',
    component: ManageRegistrationsComponent,
  },
  {
    path: 'events-bidding',
    component: ManageEventsBiddingsComponent,
  },
  {
    path: 'events-bidding/curd/:id',
    component: CurdEventsBiddingsComponent,
  },
  {
    path: 'events-bidding/curd',
    component: CurdEventsBiddingsComponent,
  },
  {
    path: 'events-feedback',
    component: EventsFeedbackComponent
  },
  {
    path: 'forums',
    component: ManageForumsComponent,
  },
  {
    path: 'forums/crud',
    component: CrudForumComponent,
  },
  {
    path: 'forums/crud/:id',
    component: CrudForumComponent,
  },
  {
    path: 'forums/registrations',
    component: ManageForumRegistrationsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventsRoutingModule { }
